export class ABOSLink {
  path: string;
  name: string;
  icon: string;
  disabled: boolean;
  permission: string;

  constructor(path: string, name: string, icon: string, disabled: boolean, permission: string) {
    this.path = path;
    this.name = name;
    this.icon = icon;
    this.disabled = disabled;
    this.permission = permission;
  }
}
